<div class="content-holder">
  <p class="body-bold-20">{{'general.check_your_inbox' | translate}}</p>
  <p class="caption12 margined slate-600">
    {{'general.we_sent_reset_email' | translate}}
    <span class="caption-bold12 slate-600">{{Email}}</span>.
    {{'general.it_might_take_time' | translate}}
  </p>
  <p class="bordered"></p>

  <button type="button" class="nake-buttonXL body-bold-14" id="back" [routerLink]="['/sign-in']">
    {{'general.back_to_signin' | translate}}
  </button>
</div>